import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { useNavigate } from 'react-router-dom';
import '../styles/howToHelp/howToHelp.min.css';

const HowToHelpSection = () => {
const navigate = useNavigate();

    const handleClick = () => {
        navigate('/como-ajudar');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
  
    const helpOptions = [
        {
          image:  '/images/how-to-help-img/img1.svg',
      title: "Se Voluntário",
    },
        {
          image:  '/images/how-to-help-img/img2.svg',
      title: "Torna-te Sócio",
    },
        {
          image:  '/images/how-to-help-img/img3.svg',
        
      title: "Faz Uma Doação",
    }
  ];
    return (
       <section id="como-ajudar" className="py-5 section-separator">
      <Container>
        <Row className="justify-content-center mb-4">
          <Col md={6} className="text-center px-4">
            <h2 className="section-title display-5 how-to-help-heading fw-bold mb-3">COMO AJUDAR?</h2>
            <p className="how-to-help-text text-start">
                            O teu apoio pode transformar vidas! Seja através do teu tempo, do teu compromisso ou de um contributo financeiro, há várias formas de fazer parte da mudança.<br/>
              </p>
              <p className='how-to-help-text text-center m-0 p-0'>
                            Escolhe como queres ajudar:
              </p>
          </Col>
        </Row>
        
        <Row className='justify-content-center'>
          {helpOptions.map((option, index) => (
            <Col key={index} md={4} className="mb-4">
              <Card className="help-option-card h-100 border-0 p-0">
                      <Card.Body className="text-center p-0">
                          <img src={option.image} alt={option.title} />
                          <div className="divider my-4"></div>
                          <button type='button' className='rounded-pill px-4 py-2 fw-bold main-btn ' onClick={handleClick}>{option.title}</button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
    );
}

export default HowToHelpSection;